import clsx from 'clsx';
import React from 'react';

import StyledLink from '1_components/StyledLink/StyledLink';

import S from './PrivacyFooter.module.scss';

import { fonts } from 'styles/fontsRegistry';

export interface PrivacyFooterProps {
  links: {
    label: string;
    url: string;
    sideEffect?: () => void;
  }[];
  className?: string;
}

const PrivacyFooter: React.FC<PrivacyFooterProps> = ({
  links,
  className,
  ...rest
}) => {
  return (
    <div className={clsx(className, S.Wrapper)} {...rest}>
      {links.map(({ url, label, sideEffect }, index) => (
        <StyledLink key={index} href={url} target="_blank" onClick={sideEffect}>
          <span className={fonts.link}>{label}</span>
        </StyledLink>
      ))}
    </div>
  );
};

export default PrivacyFooter;
